import React from "react";
import { Layout } from "../../layouts/Layout";

const ShippingPolicy = () => {
  return (
    <Layout title="Shipping Policy">
      <div className="container pt-120 pb-100">
        <div className="blog-details-content">
          <h2 className="title">Shipping Policy</h2>
          <p>
            We ensure prompt, safe, and hygienic dispatch of all products,
            maintaining full compliance with FSSAI and logistics safety
            standards.
          </p>
          <ol>
            <li>
              <h5>Coverage</h5>
              <p>
                We deliver across India using certified logistics partners. Bulk
                or institutional shipments follow separate dispatch agreements.
              </p>
            </li>
            <li>
              <h5>Processing & Timeline</h5>
              <p>Orders are processed within 2–4 business days.</p>
              <p>
                Delivery typically occurs within 3–10 business days, depending
                on region and product type.
              </p>
              <p>
                Tracking details are shared via registered contact channels.
              </p>
            </li>
            <li>
              <h5>Delays & Force Majeure</h5>
              <p>
                The Company will not be held liable for delays due to courier
                disruption, natural calamity, strikes, or unforeseen logistical
                challenges.
              </p>
            </li>
            <li>
              <h5>Packaging & Verification</h5>
              <p>All products are inspected and sealed before dispatch.</p>
              <p>
                Customers must verify package integrity at delivery. Damage
                claims must be raised within 24 hours with valid proof.
              </p>
            </li>
            <li>
              <h5>Risk Transfer</h5>
              <p>
                Ownership and risk transfer to the customer once the product is
                handed to the courier partner.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </Layout>
  );
};

export default ShippingPolicy;
